export default "__VITE_ASSET__1181216f__"